import { useMemo } from 'react';
import { formatEuViewValue, metricLabels, viewLabels } from '../../utils/euFormatters';

export default function EuRankingChart({ data, metric = 'gross', view = 'nominal' }) {
  const countries = useMemo(() => data?.countries || [], [data?.countries]);
  const max = useMemo(() => Math.max(data?.eu_average || 0, ...countries.map(item => Number(item.value) || 0), 0.00001), [countries, data?.eu_average]);
  const euPosition = data?.eu_average === null || data?.eu_average === undefined ? null : Math.min(100, (Number(data.eu_average) / max) * 100);

  if (!countries.length) return null;

  return (
    <div aria-label={`Classifica europea: ${viewLabels[view]}, ${metricLabels[metric]}`}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 text-xs font-medium text-md-on-surface-variant">
        <span>{countries.length} Paesi</span>
        {data.eu_average !== null && data.eu_average !== undefined && (
          <span className="inline-flex items-center gap-2 rounded-full bg-md-secondary-container px-3 py-2 text-md-on-secondary-container">
            <span className="h-3 w-0.5 bg-md-secondary" aria-hidden="true" /> {view === 'nominal' ? 'Media UE ufficiale' : 'Riferimento UE'} {formatEuViewValue(data.eu_average, view)}
          </span>
        )}
      </div>
      <ol className="max-h-[760px] space-y-2 overflow-y-auto pr-1" aria-label="Paesi ordinati dal valore più alto al più basso">
        {countries.map((country) => {
          const width = Math.max(2, (Number(country.value) / max) * 100);
          const italy = country.country === 'IT';
          return (
            <li key={country.country} className={`rounded-[18px] p-3 ${italy ? 'bg-md-primary-container text-md-on-primary-container' : 'bg-md-surface-container-low'}`}>
              <div className="flex items-center gap-3">
                <span className="numbers w-7 shrink-0 text-right text-xs font-bold" aria-label={`Posizione ${country.rank}`}>{country.rank}.</span>
                <div className="min-w-0 flex-1">
                  <div className="mb-2 flex items-baseline justify-between gap-3">
                    <span className={`truncate text-sm ${italy ? 'font-bold' : 'font-medium'}`}>{country.name}</span>
                    <span className="numbers shrink-0 text-sm font-bold">{formatEuViewValue(country.value, view)}</span>
                  </div>
                  <div className="relative h-2.5 overflow-hidden rounded-full bg-md-surface-container-high" aria-hidden="true">
                    <span className={`absolute inset-y-0 left-0 rounded-full ${italy ? 'bg-md-primary' : 'bg-md-secondary'}`} style={{ width: `${width}%` }} />
                    {euPosition !== null && <span className="absolute -top-1 h-4 w-0.5 bg-md-on-surface" style={{ left: `${euPosition}%` }} />}
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
